import { localStg } from '@/utils';

/** 获取锁屏状态 */
export function getLockScreenStatus() {
  return localStg.get('isLockScreen') || false;
}
